
$(document).ready(function () {
	if ($('.sectionBottom').length) {
		var target = $('.sectionBottom');
		var targetPos = target.offset().top;
		var winHeight = $(window).height();
		var scrollToElem = targetPos - winHeight;
		var it = true;
 	}
	$(window).scroll(function(){
		var winScrollTop = $(this).scrollTop();
		if(winScrollTop > scrollToElem && it==true){
			$('.sectionBottomBox__count').each(function () {
				$(this).prop('Counter',0).animate({
					Counter: $(this).text()
				}, {
					duration: 4000,
					easing: 'swing',
					step: function (now) {
						$(this).text(Math.ceil(now));
					}
				});
			});
			it = false;
		}
	});


	if ($('.countBlocks').length) {
		var target = $('.countBlocks');
		var targetPos = target.offset().top;
		var winHeight = $(window).height();
		var scrollToElem = targetPos - winHeight;
		var it = true;
	}
	$(window).scroll(function(){ 
		var winScrollTop = $(this).scrollTop();
		if(winScrollTop > scrollToElem && it==true){
			$('.countBlocks__item-count').each(function () {
				$(this).prop('Counter',0).animate({
					Counter: $(this).text()
				}, {
					duration: 4000,
					easing: 'swing',
					step: function (now) {
						$(this).text(Math.ceil(now));
					}
				});
			});
			it = false;
		}
	});



	$(".remove").hide();

	$(".main_input_file").change(function() {

			var f_name = [];

			for (var i = 0; i < $(this).get(0).files.length; ++i) {

				f_name.push( "<span class='bsp'>" + $(this).get(0).files[i].name + "</span>");


			}
			$("#f_name").html(f_name);

			$(".remove").show();
		});

$('select').selectize();
	//styling number input
   $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.filters__numberWrapper input');

		if ($(window).width() > 1020) {
			$('.sidebarMenu').stick_in_parent({
				offset_top: 120
			});
		}

	$(".hover").mouseleave(
	  function () {
	    $(this).removeClass("hover");
	  }
	);



	AOS.init({
		   disable: 'mobile',
       offset: 200,
       duration: 600,
       delay: 100,});

  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: 0
    }, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 145) {
			AOS.refresh();

      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });


	//language switcher
	$('.js-top__language').on('click',function(){
			$(this).toggleClass('top__language--open');
			return false;
	});

		//language switcher
	$('.js-top__language a:not(.active)').on('click',function(){
				$(this).addClass('active').siblings().removeClass('active');
				window.location.href = $(this).attr('href');
		});

$(".sliderHome .owl-carousel").owlCarousel({
	 items:1,
	 margin:0,
	 stagePadding:0,
	 smartSpeed:450,
	 animateOut: 'animate__animated animate__slideOutUp',
 		animateIn: 'animate__animated animate__fadeIn',
	 autoplay:true,
	 nav:true,
	 navText : ["",""],
	 loop:true,
	 dots:true,
	 autoplayTimeout:7000,
	 autoplayHoverPause:true
});

$(".slider--sub .owl-carousel").owlCarousel({
	items:1,
	margin:0,
	stagePadding:0,
	smartSpeed:450,
	animateOut: 'fadeOut',
	animateIn: 'fadeIn',
	autoplay:true,
	nav:true,
	navText : ["",""],
	loop:true,
	dots:true,
	autoplayTimeout:7000,
	autoplayHoverPause:true
});
	var didScroll = false,
    header = document.querySelector('.header'),
    body = document.querySelector('html, body'),
    ms = document.querySelector('body');

  function scrollTrue() {
    didScroll = true;
  }

  function isOnViewPoint() {
    if ((body.scrollTop || ms.scrollTop) >= 100) {
      header.classList.add('short');
    } else {
      header.classList.remove('short');
    }
  }

  window.addEventListener('scroll', scrollTrue);
  document.onscroll = scrollTrue();

  setInterval(function () {
    if (didScroll) {
      didScroll = false;
      isOnViewPoint();
    }
  });


	$(function(){
	  $('a[href^="#"]').on('click', function(event) {

	    event.preventDefault();

	    var sc = $(this).attr("href"),
	        dn = $(sc).offset().top - 200;


	    $('html, body').animate({scrollTop: dn}, 1000);

	  });
	});

	$("[data-contact-mapchange]").bind('click',function(){
		var map = $(this).parent().find('[data-contact-mapbox]').html();
		$("#map").html(map);
	});
});


var file = document.querySelector('.main_input_file');
removeBtn = document.querySelector('.remove');

if(removeBtn){
	removeBtn.addEventListener('click', function () {
		$(".remove").hide();
		$("#f_name").hide();
		file.value = '';
	}, false);
}
